import { env } from "@/env";
import { Err } from "./errors";
import { Merchant } from "@/types/merchant";
import { COMMON_FETCH_HEADERS } from "./utils";

export const volume = {
  admin: {
    /**
     * /api/merchants
     * GET
     */
    GetMerchants: async ({ accessToken }: { accessToken: string }) => {
      const getMerchantsResponse = await fetch(
        `${env.VITE_VOLUME_URL}/api/merchants`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            ...COMMON_FETCH_HEADERS,
          },
        },
      );
      if (!getMerchantsResponse.ok) {
        if (getMerchantsResponse.status === 401) {
          console.info("/api/merchants Unauthorized");
          return Err(getMerchantsResponse.statusText, "UNAUTHORIZED");
        }
        return Err(getMerchantsResponse.statusText, "API_NOT_OK_RESPONSE");
      }
      return (await getMerchantsResponse.json()) as Merchant[];
    },
  },
  merchant: {
    CreateMerchantAccount: async ({
      companyName,
      email,
      fullName,
      phoneNumber,
    }: {
      email: string;
      companyName: string;
      phoneNumber?: string;
      fullName?: string;
    }) => {
      const createMerchantAccountResponse = await fetch(
        `${env.VITE_VOLUME_URL}/api/merchants/create-with-non-virtual-pay-in-account/sandbox`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${btoa(
              `${env.VITE_SIGNUP_EMAIL}:${env.VITE_SIGNUP_PASSWORD}`,
            )}`,
            Accept: "application/vnd.volume.v0.7+json",
            "Content-Type": "application/vnd.volume.v0.7+json",
            ...COMMON_FETCH_HEADERS,
          },
          body: JSON.stringify({
            accountEmail: email,
            fullName: null,
            companyDetails: {
              name: companyName,
              personName: fullName ?? null,
              phoneNumber: phoneNumber ?? null,
            },
            welcomeMessageTemplateId: "default",
            payInAccountDetails: {
              accountHolderName: null,
              accountNumber: null,
              sortCode: null,
              address: {
                streetName: null,
                buildingNumber: null,
                postCode: null,
                townName: null,
                country: null,
                department: null,
                subDepartment: null,
                addressType: null,
              },
            },
            configuration: {
              merchantCallbackUrlForMobile: null,
              merchantCallbackUrlForWeb: null,
              paymentsWebhookUrl: null,
            },
            onboardingDetails: {
              industry: null,
              websiteUrl: null,
              expectedMonthlyTransactionVolume: null,
            },
          }),
        },
      );
      if (!createMerchantAccountResponse.ok) {
        if (createMerchantAccountResponse.status === 401) {
          return Err(createMerchantAccountResponse.statusText, "UNAUTHORIZED");
        }
        if (createMerchantAccountResponse.status === 409) {
          return Err(
            createMerchantAccountResponse.statusText,
            "ACCOUNT_EXISTS",
          );
        }
        return Err(
          createMerchantAccountResponse.statusText,
          "API_NOT_OK_RESPONSE",
        );
      }
      return (await createMerchantAccountResponse.json()) as object;
    },
  },
} as const;
